import { RootState, SetState } from '@/store/useStore.ts';
import {
  DEFAULT_THEME,
  INITIAL_THEMES,
  Themes,
  ThemeSlice,
} from '@/store/slices/theme/types';

export type { Themes, ThemeSlice };

export const themeSlice = ({ set, get }: SetState<RootState>): ThemeSlice => ({
  theme: DEFAULT_THEME,
  themes: [...INITIAL_THEMES],
  addTheme: (name: string) => {
    if (!name || typeof name !== 'string') return;
    const next = name as Themes;
    const { themes } = get();
    if (themes.includes(next)) return;
    set(
      (state: RootState) => ({ ...state, themes: [...themes, next] }),
      false,
      'theme/addTheme',
    );
  },
  changeTheme: (name: string) => {
    if (!name || typeof name !== 'string') return;
    const next = name as Themes;
    const { themes } = get();
    const updated = themes.includes(next) ? themes : [...themes, next];
    set(
      (state: RootState) => ({ ...state, theme: next, themes: updated }),
      false,
      'theme/changeTheme',
    );
  },
  resetTheme: () => {
    set(
      (state: RootState) => ({ ...state, theme: DEFAULT_THEME }),
      false,
      'theme/resetTheme',
    );
  },
});
